<template>
<div class="chapter">
<div class="inner_page">
<p class="C218"><a id="page_1">PART ONE</a></p><a id="page_1">
<p class="C219">HUMEAN REFLECTIONS</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part_One__Humean_Reflections.vue?58fe2935